"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var formik_1 = require("formik");
var react_query_1 = require("react-query");
var axios_1 = __importDefault(require("axios"));
var FormikPhoneField = function (_a) {
    var setFieldValue = _a.setFieldValue, props = __rest(_a, ["setFieldValue"]);
    var _b = (0, react_query_1.useQuery)('phoneNumbers', function () { return axios_1.default.get('/country-phone-numbers').then(function (result) { return result.data; }); }), data = _b.data, isLoading = _b.isLoading;
    var _c = react_1.default.useState(), value = _c[0], setValue = _c[1];
    var _d = react_1.default.useState(''), inputValue = _d[0], setInputValue = _d[1];
    var _e = (0, formik_1.useField)(props), field = _e[0], meta = _e[1];
    (0, react_1.useEffect)(function () {
        setFieldValue(field.name, 'NL');
    }, []);
    if (isLoading) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ component: "fieldset", error: meta.touched && meta.error !== undefined, sx: { flexDirection: 'row', alignItems: 'baseline' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Autocomplete, { fullWidth: true, defaultValue: data === null || data === void 0 ? void 0 : data.find(function (phoneNumber) {
                        if (phoneNumber.id === 'NL') {
                            return phoneNumber;
                        }
                        return null;
                    }), value: value, onChange: function (event, newValue) {
                        setFieldValue(field.name, newValue.id);
                        setValue(newValue);
                    }, inputValue: inputValue, onInputChange: function (event, newInputValue) {
                        setInputValue(newInputValue);
                    }, options: data || [], getOptionLabel: function (option) { return option.label; }, renderInput: function (params) { return (0, jsx_runtime_1.jsx)(material_1.TextField, __assign({}, params, { sx: props.sx })); } }) })), meta.touched && meta.error && (0, jsx_runtime_1.jsx)(material_1.FormHelperText, __assign({ sx: { color: '#d32f2f' } }, { children: meta.error }))] }));
};
exports.default = FormikPhoneField;
